// @ts-nocheck

import { walkDir, removeIndex, isIndexEnd } from "./util";
import * as Joi from "joi";
const path = require("path")
const fs = require("fs")

const routes = ["所有路由路径："];

class routePlugin {
  public name: string = "routePlugin";
  public version: string = "0.0.1";
  public register(server: any, options: any) {
    const sourceDir = options.sourceDir;
    const type = options.type || "jwt";

    const files = walkDir(sourceDir);
    files.forEach((file) => {
      let filename = file.relativeFileNoExt;
      let array = filename.split(path.sep).slice(1);
      let fileNoExt = removeIndex("/" + array.join("/"));
      const moduleName = path.resolve(sourceDir, filename);
      const obj = require(moduleName);
      if (obj.default) {
        const func = new (obj.default || obj)();
        const prototype = Object.getPrototypeOf(func);
        const keys = Reflect.ownKeys(prototype);
        for (const key of keys) {
          if (key !== "constructor") {
            let ff = func[key];
            // 默认方法
            const method = ff.$method || "GET";
            // 路由收集规则
            let route = "";
            if (ff.$route) {
              if (isIndexEnd(fileNoExt)) {
                route = ff.$route;
              } else {
                route = fileNoExt + ff.$route;
              }
            } else {
              if (isIndexEnd(fileNoExt)) {
                route = fileNoExt + key.toString();
              } else {
                route = fileNoExt + "/" + key.toString();
              }
            }
            route = removeIndex(route);
            // 配置规则
            const options = ff.$options ? ff.$options : {};
            if (!options.auth) {
              if (ff.$auth == undefined) {
                if (route.startsWith("/api")) {
                  options.auth = type;
                } else {
                  options.auth = false;
                }
              } else if (ff.$auth) {
                options.auth = type;
              } else {
                options.auth = false;
              }
            }
            if (!options.validate) {
              let validateObj = ff.$validate || {};
              if(options.auth&&type === "jwt"){
                if (validateObj.headers) {
                  validateObj.headers = validateObj.headers.keys({
                    Authorization: Joi.string(),
                  })
                }else{
                  validateObj.headers = Joi.object({
                    headers: Joi.object({
                      Authorization: Joi.string(),
                    }).unknown(), // 注意加上这个
                  })
                }
              }
              if (validateObj) {
                options.validate = validateObj;
              }
            }
            // && route.startsWith("/api")
            if (ff.$swagger) {
              options.description = ff.$swagger[0];
              options.notes = ff.$swagger[1];
              options.tags = ff.$swagger[2];
            }
            let str = route;
            if (options.auth) {
              str += " 该路由需要权限";
            } else {
              str += " 该路由不需要权限";
            }
            routes.push(str);
            server.route({
              method: method,
              path: route,
              handler: ff,
              options: options,
            });
          }
        }
      }
    });
    fs.writeFileSync(path.resolve(sourceDir, "route.txt"), routes.join("\n"), {
      encoding: "utf-8",
    });
  }
}

const plugin = new routePlugin();

export { plugin };
export * from "./util/decorators";
